import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "pulse-dashboard" }
const _hoisted_2 = { class: "opts" }
const _hoisted_3 = { class: "col calendar" }
const _hoisted_4 = {
  key: 0,
  class: "date-range"
}
const _hoisted_5 = {
  key: 1,
  class: "date-range required"
}
const _hoisted_6 = { class: "field-row" }
const _hoisted_7 = { class: "field-row" }
const _hoisted_8 = { class: "field-row" }
const _hoisted_9 = { class: "switch-row" }
const _hoisted_10 = { class: "switch-row" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DropdownCalendar = _resolveComponent("DropdownCalendar")
  const _component_el_select_v2 = _resolveComponent("el-select-v2")
  const _component_el_input_number = _resolveComponent("el-input-number")
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_Divider = _resolveComponent("Divider")
  const _component_TasksRunner = _resolveComponent("TasksRunner")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TasksRunner, {
      class: "dashboard",
      "can-run": $options.can_run,
      "runner-id": "adm_pulse_dashboard",
      caption: "Pulse Dashboard",
      runner: $options.runPulseDashboard
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_DropdownCalendar, {
              modelValue: $data.filter_dates,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.filter_dates) = $event)),
              "filter-indicator": false,
              title: "Date Range",
              "min-date": $options.min_date
            }, null, 8 /* PROPS */, ["modelValue", "min-date"]),
            (!!$data.filter_dates.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($options.date), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, " Select date range "))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "label" }, "Bin Size", -1 /* HOISTED */)),
            _createVNode(_component_el_select_v2, {
              modelValue: $data.bin_size,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.bin_size) = $event)),
              class: "bin-size",
              options: $data.bin_size_items,
              placeholder: "Select bin size",
              teleported: false
            }, null, 8 /* PROPS */, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "label" }, "Stale Threshold Hours", -1 /* HOISTED */)),
            _createVNode(_component_el_input_number, {
              modelValue: $data.stale_threshold_hours,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.stale_threshold_hours) = $event)),
              class: "number",
              min: 0.1,
              step: 1,
              "controls-position": "right"
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "label" }, "Trailing Days", -1 /* HOISTED */)),
            _createVNode(_component_el_input_number, {
              modelValue: $data.trailing_days,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.trailing_days) = $event)),
              class: "number",
              min: 1,
              step: 1,
              precision: 0,
              "controls-position": "right"
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "label" }, "Compare", -1 /* HOISTED */)),
            _createVNode(_component_el_switch, {
              modelValue: $data.compare,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.compare) = $event))
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "label" }, "Fetch Channels", -1 /* HOISTED */)),
            _createVNode(_component_el_switch, {
              modelValue: $data.fetch_channels,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.fetch_channels) = $event))
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _createVNode(_component_Divider)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["can-run", "runner"])
  ]))
}